var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.900391C14.2302 0.900391 18.0996 4.76977 18.0996 9.5C18.0996 14.2302 14.2302 18.0996 9.5 18.0996C4.76977 18.0996 0.900391 14.2302 0.900391 9.5C0.900391 4.76977 4.76977 0.900391 9.5 0.900391ZM4.15234 5.4834C3.27808 6.55762 2.7998 7.94693 2.7998 9.5C2.7998 13.1848 5.81523 16.2002 9.5 16.2002C11.053 16.2002 12.4414 15.7209 13.5156 14.8467L4.15234 5.4834ZM9.5 2.7998C7.94693 2.7998 6.55762 3.27808 5.4834 4.15234L14.8398 13.5088C15.6444 12.3502 16.2002 10.9631 16.2002 9.5C16.2002 5.81523 13.1848 2.7998 9.5 2.7998Z",
    fill: "#777777",
    stroke: "#777777",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.cc938fc98da77e4b99c9b830878d61ff.svg";
export { ForwardRef as ReactComponent };